import "./back_button.css";
import { HashLink } from "react-router-hash-link";

import MediaRessources from "../../ressources/media-ressources";

function Back_Button({ link }) {
  return (
    <>
      <HashLink className="button-backdown" to={link}>
        <img
          src={MediaRessources.chevronDown}
          width={30}
          height={30}
          alt="Icone de flèche en direction de la gauche pour signifier un retour à la page principal"
        />
        Retour
      </HashLink>
    </>
  );
}

export default Back_Button;
